import React, { useState } from "react";

// ASSETS
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";

// STYLES
import {
  PersonnelCarouselContainer,
  PersonnelCardItem,
  SeeMoreButton,
  SeeLessButton,
  CardsContainer,
} from "./PersonnelWrapperStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./PersonnelWrapperModel";

// REDUX

// COMPONENTS
import PersonnelCard from "components/PersonnelCard/PersonnelCard";
import { PersonnelCardType } from "components/PersonnelCard/PersonnelCardModel";
import useWindowWidth from "hooks/useWindowWidth";

const PersonnelWrapper = (props: IProps) => {
  // PROPERTIES
  const { data, handleClick } = props;

  // LIBRARY CONSTANTS
  const windowWidth = useWindowWidth();
  const { t } = useTranslation();

  // STATE CONSTANTS
  const [initialCards, setInitialCards] = useState(windowWidth < 1024 ? 3 : 6);

  const [visibleCount, setVisibleCount] = useState(initialCards);

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const handleSeeMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 6, data?.length || 0));
  };

  const handleSeeLess = () => setVisibleCount(initialCards);

  return (
    <PersonnelCarouselContainer>
      <CardsContainer>
        {data?.slice(0, visibleCount).map((item) => (
          <PersonnelCardItem key={item?.id} onClick={() => handleClick(item)}>
            <PersonnelCard
              image={item?.image?.trim() ? item.image : CoverPlaceholder}
              fullName={item?.fullName}
              occupation={item?.occupation}
              type={PersonnelCardType.Fixed}
            />
          </PersonnelCardItem>
        ))}
      </CardsContainer>
      {visibleCount < data?.length && (
        <SeeMoreButton onClick={handleSeeMore}>
          {t("view.about.aboutDSU.personnelSection.card.more")}
        </SeeMoreButton>
      )}
      {visibleCount >= data?.length && data?.length > initialCards && (
        <SeeLessButton onClick={handleSeeLess}>
          {t("view.about.aboutDSU.personnelSection.card.less")}
        </SeeLessButton>
      )}
    </PersonnelCarouselContainer>
  );
};

export default PersonnelWrapper;
